var _path, _path2, _path3, _ellipse, _path4, _path5, _path6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRedBox = function SvgRedBox(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 71,
    viewBox: "0 0 81 71",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0234 19.3844L42.0234 7.80068C43.8672 6.73311 46.1328 6.73311 47.9766 7.80068L67.9766 19.3844C68.3162 19.5801 68.2668 20.059 67.9134 20.2286L45.6491 30.9164C45.2388 31.1134 44.7612 31.1134 44.3509 30.9164L22.0866 20.2286C21.7332 20.059 21.6838 19.5801 22.0234 19.3844Z",
    fill: "#E34B4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 35.6979C47 35.121 47.3308 34.5953 47.8508 34.3457L70.3749 23.5326C70.6172 23.4163 70.9049 23.5562 70.9427 23.8223C70.9805 24.0994 71 24.3805 71 24.6642V47.6838C71 49.8665 69.8464 51.8816 67.9766 52.9637L47.9766 64.5474C47.5221 64.81 47 64.4471 47 63.9222V35.6979Z",
    fill: "#E34B4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1492 34.3457C42.6692 34.5953 43 35.121 43 35.6979V63.9222C43 64.4471 42.4779 64.81 42.0234 64.5474L22.0234 52.9637C20.1536 51.8816 19 49.8665 19 47.6838V24.6642C19 24.6264 19.0003 24.5886 19.001 24.5508C19.0128 23.9079 19.7045 23.5707 20.2842 23.849L42.1492 34.3457Z",
    fill: "#E34B4B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.9461,
    cy: 22.9909,
    rx: 18.3264,
    ry: 18.3659,
    fill: "#E34B4B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.889 22.9896C41.889 34.5819 32.5118 43.9793 20.9445 43.9793C9.37717 43.9793 0 34.5819 0 22.9896C0 11.3974 9.37717 2 20.9445 2C32.5118 2 41.889 11.3974 41.889 22.9896ZM20.9445 41.3556C31.0659 41.3556 39.2709 33.1329 39.2709 22.9896C39.2709 12.8464 31.0659 4.6237 20.9445 4.6237C10.8231 4.6237 2.61806 12.8464 2.61806 22.9896C2.61806 33.1329 10.8231 41.3556 20.9445 41.3556Z",
    fill: "#FF8888"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8896 15.0068L13.0095 31.8869",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8941 31.8977L13 15",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRedBox, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/RedBox.e9fe3b73.svg";
export { ForwardRef as ReactComponent };